import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

function HashAnchor({ id, children, use = 'div' }) {
  const ref = useRef()

  useEffect(() => {
    const elementId = window.location.hash.slice(1)
    if (!elementId) return
    if (elementId !== id) return
    if (!ref.current) return

    ref.current.scrollIntoView()
  }, [id])

  return React.createElement(use, { id, ref }, children)
}

HashAnchor.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  use: PropTypes.string,
}

export default HashAnchor
